import React from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { CompanyReportSectionType } from '../metroline/types';
import { CompanyReportSection } from '../types';
import { TextsContainer } from './texts-container';

export const Texts: React.FC<CompanyReportSection> = ({
  companyReportItem, textsValidation, translation, section,
  getRef, shouldRenderSection, loadOptions, locale, options, validation, updateTextItem,
  updateTextItemDescription, removeText, addText, removeAllTexts,
  resetTextValidation, resetTextsValidation, translationAdminAccess
}) =>
  <MetroLineSection<CompanyReportSectionType>
    section={section}
    sectionType={CompanyReportSectionType.Texts}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(CompanyReportSectionType.Texts)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={CompanyReportSectionType.Texts}
        validation={undefined}
        info={{ text: translation.texts_title }}
        label={{ visible: true, text: translation.texts_title }} />
      <MainGridContainer className="mt-3">
        <TextsContainer
          companyReportItem={companyReportItem}

          updateTextItem={updateTextItem}
          updateTextItemDescription={updateTextItemDescription}
          removeText={removeText}
          removeAllTexts={removeAllTexts}
          addText={addText}
          resetTextValidation={resetTextValidation}
          resetTextsValidation={resetTextsValidation}

          textsValidation={textsValidation}
          validation={validation}

          loadOptions={loadOptions}
          locale={locale}
          options={options}
          translation={translation}
          translationAdminAccess={translationAdminAccess} />

      </MainGridContainer>
    </div>
  </MetroLineSection>;
